import { render, staticRenderFns } from "./RirekishoDoubleNophotoPreview.vue?vue&type=template&id=407a57e9"
import script from "./RirekishoDoubleNophotoPreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./RirekishoDoubleNophotoPreview.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports